var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useRef, useEffect, useLayoutEffect, useContext, } from 'react';
import classnames from 'classnames';
import "./styles.css";
import { DropdownMenu } from '../DropdownMenu';
import { useBEM, PopupsContext } from '../../utils';
var _a = useBEM('lk-ui__select'), _selectClassName = _a[0], _selectModifier = _a[1], selectElement = _a[2];
var _b = selectElement('options'), optionsClassName = _b[0], _optionsModifier = _b[1], optionsElement = _b[2];
var itemClassName = optionsElement('item')[0];
export var SelectDropdown = function (_a) {
    var _b;
    var multiple = _a.multiple, values = _a.values, onChange = _a.onChange, options = _a.options, onOutsideClick = _a.onOutsideClick, makeOption = _a.makeOption, parentRef = _a.parentRef;
    var optionsRef = useRef(null);
    var rootElement = useContext(PopupsContext).rootElement;
    var _c = useState((_b = parentRef.current) === null || _b === void 0 ? void 0 : _b.clientWidth), dropdownWidth = _c[0], setDropdownWidth = _c[1];
    useLayoutEffect(function () {
        var _a;
        setDropdownWidth((_a = parentRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth);
    });
    var onSelectItem = function (item) { return function (e) {
        onChange([item]);
        e.stopPropagation();
    }; };
    var onMultiselectItem = function (item) { return function (e) {
        var itemIndex = values.findIndex(function (value) { return item.id === value.id; });
        var isAddition = itemIndex === -1;
        var updItems = isAddition
            ? __spreadArray(__spreadArray([], values, true), [item], false) : values.filter(function (_, i) { return itemIndex !== i; });
        onChange(updItems);
        e.stopPropagation();
    }; };
    useEffect(function () {
        var handleOutsideClick = function (event) {
            var targetElement = event === null || event === void 0 ? void 0 : event.target;
            var inputElement = parentRef === null || parentRef === void 0 ? void 0 : parentRef.current;
            var optionsElement = optionsRef === null || optionsRef === void 0 ? void 0 : optionsRef.current;
            var isOutsideClick = ![inputElement, optionsElement].some(function (element) { return element && element.contains(targetElement); });
            if (isOutsideClick) {
                onOutsideClick === null || onOutsideClick === void 0 ? void 0 : onOutsideClick();
            }
        };
        var listenerContainer = rootElement || window;
        listenerContainer.addEventListener('mousedown', handleOutsideClick);
        return function () { return listenerContainer.removeEventListener('mousedown', handleOutsideClick); };
    }, []);
    var makeItem = function (item, isSelected) {
        var className = classnames(itemClassName, {
            selected: isSelected,
        });
        var onClickHandler = multiple ? onMultiselectItem : onSelectItem;
        return (React.createElement("div", { className: className, onClick: onClickHandler(item), key: item.id.toString() }, makeOption(item, isSelected)));
    };
    var makeOptions = function (selectedItems, options) {
        return (React.createElement("div", { className: optionsClassName, ref: optionsRef, style: { width: dropdownWidth } }, options.map(function (item) {
            return makeItem(item, selectedItems.some(function (i) { return i.id === item.id; }));
        })));
    };
    var optionsComponents = makeOptions(values, options);
    var dropdownMenuProps = {
        targetElement: parentRef,
        align: 'center',
        verticalOffset: 0,
    };
    return (React.createElement(DropdownMenu, __assign({}, dropdownMenuProps), optionsComponents));
};
